function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
} // @flow


import React, { useState } from 'react';
import DefaultTheme from './theme';
import Input from '../input';
import Select from '../select';
import FormElement from '../form-element';
import { COUNTRIES as COUNTRIES_OBJECT } from './constants';
export var COUNTRIES = COUNTRIES_OBJECT;
export var PhoneInputTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { InputThemeType } from '../input';
import type { OptionType } from '../select';
import type { SelectThemeType } from '../select/theme';
import type { FormElementThemeType } from '../form-element';

type Country = {|
  label: string;
  prefix: string;
|};

export type PhoneInputThemeType = {|
  Main: * => Node,
  SelectContainer: * => Node,
  Select: SelectThemeType,
  SelectFormElement: FormElementThemeType;
  InputComponent: InputThemeType,
  InputFormElement: FormElementThemeType
|};

export type PhoneInputValue = {|
  prefix: ?OptionType,
  number: string,
|};

type Props = {
 prefixes?: Country[];
 value?: ?PhoneInputValue,
 onChange?: (value: ?PhoneInputValue) => any;
 inputLabel?: string;
 inputPlaceholder?: string;
 prefixPlaceholder?: string;
 disabled?: boolean;
 error?: string;
 hint?: string;
 autocomplete?: string;
 required?: boolean;
 theme?: PhoneInputThemeType,
};
*/

/**
 * Cannot use Object.values here:
 * https://github.com/facebook/flow/issues/2221
 */

var countries = Object.keys(COUNTRIES).map(function (key) {
  return {
    label: COUNTRIES[key].label,
    prefix: COUNTRIES[key].dialCode
  };
});

var PhoneInput = function PhoneInput(_ref
/*: Props */
) {
  var value = _ref.value,
      inputPlaceholder = _ref.inputPlaceholder,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$inputLabel = _ref.inputLabel,
      inputLabel = _ref$inputLabel === void 0 ? 'Phone Number' : _ref$inputLabel,
      _ref$prefixPlaceholde = _ref.prefixPlaceholder,
      prefixPlaceholder = _ref$prefixPlaceholde === void 0 ? 'Country Code' : _ref$prefixPlaceholde,
      _ref$prefixes = _ref.prefixes,
      prefixes = _ref$prefixes === void 0 ? countries : _ref$prefixes,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? '' : _ref$hint,
      _ref$autocomplete = _ref.autocomplete,
      autocomplete = _ref$autocomplete === void 0 ? 'off' : _ref$autocomplete,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;

  var _useState = useState(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var onInternalChange = function onInternalChange(country, number) {
    var prefix = Array.isArray(country) ? country[0] : country;
    var longestMatch; // Idea: if country code is in number, auto-move it to Select
    // take number and match first digits with all countries
    // find the longest matching prefix
    // replace it

    if (prefix && prefix.value && number.startsWith('+')) {
      var matches = countries.filter(function (c) {
        return number.startsWith(c.prefix);
      });

      if (matches.length) {
        longestMatch = matches[0]; // eslint-disable-next-line

        for (var _iterator = _createForOfIteratorHelperLoose(matches), _step; !(_step = _iterator()).done;) {
          var match = _step.value;

          if (match.prefix.length > longestMatch.prefix.length) {
            longestMatch = match;
          }
        }
      }
    }

    if (longestMatch) {
      prefix = {
        value: longestMatch.prefix,
        label: longestMatch.prefix
      }; // eslint-disable-next-line no-param-reassign

      number = number.replace(prefix.value, '');
    }

    onChange({
      prefix: prefix,
      number: number
    });
  };

  return /*#__PURE__*/React.createElement(theme.Main, {
    focused: focused,
    onFocus: function onFocus() {
      setFocused(true);
    },
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, /*#__PURE__*/React.createElement(theme.SelectContainer, {
    dir: "ltr",
    "data-test": "phone-input-select-container"
  }, /*#__PURE__*/React.createElement(FormElement, {
    label: prefixPlaceholder,
    hasValue: !!(value && value.prefix),
    disabled: disabled,
    forceLabel: true,
    error: error,
    hint: hint,
    theme: theme.SelectFormElement,
    "data-test": "phone-input-select-form-element"
  }, /*#__PURE__*/React.createElement(Select, {
    options: prefixes.map(function (_ref2) {
      var prefix = _ref2.prefix,
          label = _ref2.label;
      return {
        value: prefix,
        label: label
      };
    }),
    value: value && value.prefix,
    onChange: function onChange(option) {
      return onInternalChange(option, value && value.number ? value.number : '');
    },
    theme: theme.Select,
    "data-test": "phone-input-select"
  }))), /*#__PURE__*/React.createElement(FormElement, {
    label: inputLabel,
    hasValue: !!(value && value.number),
    disabled: disabled,
    required: required,
    theme: theme.InputFormElement,
    "data-test": "phone-input-input-form-element"
  }, /*#__PURE__*/React.createElement(Input, {
    value: value && value.number ? value.number : '',
    onChange: function onChange(text) {
      return onInternalChange(value && value.prefix, text);
    },
    error: !!error,
    theme: theme.InputComponent,
    autocomplete: autocomplete,
    "data-test": "phone-input-input",
    placeholder: inputPlaceholder
  })));
};

export default PhoneInput;